export welcome from '../../images/trickstrat/welcome.png';

export blooddrive from '../../images/gears4/blooddrive.jpg';
export impact from '../../images/gears4/impact.png';
export dam from '../../images/gears4/dam.png';
export reclaimed from '../../images/gears4/reclaimed.png';
export lift from '../../images/gears4/lift.png';
export harbor from '../../images/gears4/harbor.png';
export foundation from '../../images/gears4/foundation.png';
export diner from '../../images/gears4/diner.png';
export forge from '../../images/gears4/forge.png';
export theslab from '../../images/gears4/theslab.png';
export oldtown from '../../images/gears4/oldtown.png';

export inferno from '../../images/csgo/inferno.png';
export train from '../../images/csgo/train.png';
export mirage from '../../images/csgo/mirage.png';
export nuke from '../../images/csgo/nuke.png';
export cobblestone from '../../images/csgo/cobblestone.png';
export overpass from '../../images/csgo/overpass.png';
export cache from '../../images/csgo/cache.png';

export promenade from '../../images/lawbreakers/promenade.png';
export reactor from '../../images/lawbreakers/reactor.png';
export redfalls from '../../images/lawbreakers/redfalls.png';
export station from '../../images/lawbreakers/station.png';
export trench from '../../images/lawbreakers/trench.png';
export vertigo from '../../images/lawbreakers/vertigo.png';
export grandview from '../../images/lawbreakers/grandview.png';
export mammoth from '../../images/lawbreakers/mammoth.png';

export soccer from '../../images/sports/soccer.png';
export football from '../../images/sports/football.png';
export basketball from '../../images/sports/basketball.png';
export baseball from '../../images/sports/baseball.png';
export hockey from '../../images/sports/hockey.png';

export bank1 from '../../images/rs6/bank1.png';
export bank2 from '../../images/rs6/bank2.png';
export bank3 from '../../images/rs6/bank3.png';
export bank4 from '../../images/rs6/bank4.png';
export clubhouse1 from '../../images/rs6/clubhouse1.png';
export clubhouse2 from '../../images/rs6/clubhouse2.png';
export clubhouse3 from '../../images/rs6/clubhouse3.png';
export clubhouse4 from '../../images/rs6/clubhouse4.png';

export asylum from '../../images/gears5/asylum.png';
export bunker from '../../images/gears5/bunker.png';
export district from '../../images/gears5/district.png';
export exhibit from '../../images/gears5/exhibit.png';
export icebound from '../../images/gears5/icebound.png';
export traininggrounds from '../../images/gears5/traininggrounds.png';
export vasgar from '../../images/gears5/vasgar.png';

export bind from '../../images/valorant/bind.png';
export haven from '../../images/valorant/haven.png';
export split from '../../images/valorant/split.png';
export ascent from '../../images/valorant/ascent.png';

export canals from '../../images/roguecompany/canals.png';
export factory from '../../images/roguecompany/factory.png';
export favelas from '../../images/roguecompany/favelas.png';
export skyfell from '../../images/roguecompany/skyfell.png';
export windward from '../../images/roguecompany/windward.png';
export icarus from '../../images/roguecompany/icarus.png';
export vice from '../../images/roguecompany/vice.png';
export highcastle from '../../images/roguecompany/highcastle.png';





// WEBPACK FOOTER //
// ./src/app/utils/maps/image_paths.jsx